import useSWR from 'swr'
import API from '../../../utils/api'
import { useToken } from '../auth/token'

let page = 1
let search = ''
let KEY: string | null = null

export function useNotice() {
	const { data: token } = useToken()

	if (page > 0) {
		KEY = `/notice/list?page=${page}&search=${search}`
	}

	const { data, mutate } = useSWR<any>(
		KEY ? KEY : null,
		async () => {
			const response = await API.get(KEY + '', token + '', {})
			return response?.result
		},
		{ dedupingInterval: 10000 }
	)

	return {
		data,
		search,
		mutate: async (value?: any) => {
			if (value) {
				page = value
			}
			return mutate()
		},
		searchApi: async (value?: any) => {
			if (value !== undefined) {
				search = value
			}
			page = 1
			KEY = `/notice/list?page=${page}&search=${search}`
			return mutate()
		},
		createNotice: async (value: any) => {
			const res = await API.send(
				'POST',
				'/notice/post',
				token + '',
				{
					title: value.title,
					content: value.content,
					images: value.images,
					isFixed: value.isFixed
				}
			)

			if (res?.message === 'success') {
				return mutate()
			} else {
				return () => {}
			}
		},
		deleteNotice: async (id?: any) => {
			const res = await API.send('DELETE', `/notice/${id}`, token, {})

			if (res?.message === 'success') {
				return mutate()
			} else {
				return () => {}
			}
		},
		updateNotice: async (value: any) => {
			const res = await API.send(
				'PUT',
				`/notice/${value.id}`,
				token + '',
				{
					title: value.title,
					content: value.content,
					images: value.images,
					isFixed: value.isFixed
				}
			)
			if (res?.message === 'success') {
				return mutate()
			} else {
				return () => {}
			}
		},
	}
}
